import { useEffect, useState } from 'react';
import { getLastDateOfMonth, getLastDateOfNextMonthAsString, todayYYYYMMDD, toMonthYYYMMDD } from '../utils/formatDate';
import dayjs from 'dayjs';

const toDay = todayYYYYMMDD();
const firstDateOfMonth = toMonthYYYMMDD();
const lastDayOfMonth = getLastDateOfMonth();
const lastDateOfNextMonth = getLastDateOfNextMonthAsString();

const getRangeStr = (rangeTerm: 'day' | 'month' | '2months' | 'monthTilToday') => {
  if (rangeTerm === 'month') return { start: firstDateOfMonth, end: lastDayOfMonth };
  if (rangeTerm === '2months') return { start: firstDateOfMonth, end: lastDateOfNextMonth };
  if (rangeTerm === 'monthTilToday') return { start: firstDateOfMonth, end: toDay };
  return { start: toDay, end: toDay };
};

const getInitRange = (rangeTerm: 'day' | 'month' | '2months' | 'monthTilToday') => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 현재 달 (0부터 시작)
  const nextMonth = today.getMonth() + 1;
  const firstDate = new Date(year, month, 1);
  const lastDate = new Date(year, nextMonth, 0);
  const lastDateNextMonth = new Date(year, nextMonth + 1, 0); // 다음 달의 마지막 날

  if (rangeTerm === 'month') return { startDate: firstDate, endDate: lastDate };
  if (rangeTerm === '2months') return { startDate: firstDate, endDate: lastDateNextMonth };
  if (rangeTerm === 'monthTilToday') return { startDate: firstDate, endDate: today };
  return { startDate: today, endDate: today };
};

const useDateRange = (rangeTerm: 'day' | 'month' | '2months' | 'monthTilToday') => {
  const { start, end } = getRangeStr(rangeTerm);
  const { startDate, endDate } = getInitRange(rangeTerm);
  const [dateRange, setDateRange] = useState([{ startDate, endDate, key: 'selection' }]);
  const [userInputDateRange, setUserInputDateRange] = useState({ start, end });

  useEffect(() => {
    if (!dateRange[0].startDate) return;
    setUserInputDateRange((prev: any) => ({ ...prev, start: dayjs(dateRange[0].startDate).format('YYYY-MM-DD') }));
  }, [dateRange[0].startDate]);

  useEffect(() => {
    if (!dateRange[0].endDate) return;
    setUserInputDateRange((prev: any) => ({ ...prev, end: dayjs(dateRange[0].endDate).format('YYYY-MM-DD') }));
  }, [dateRange[0].endDate]);

  const initiateDate = () => {
    setDateRange([{ startDate, endDate, key: 'selection' }]);
  };

  return { dateRange, setDateRange, userInputDateRange, setUserInputDateRange, initiateDate };
};

export default useDateRange;
